import { Box, Button, ButtonProps, useId, useRadio, UseRadioProps } from '@chakra-ui/react';
import * as React from 'react';

export interface ToggleButtonProps extends ButtonProps {
  value: string;
  radioprops?: UseRadioProps;
}

export const ToggleButton = (props: ToggleButtonProps) => {
  const { radioprops, children, ...rest } = props;
  const { getInputProps, getCheckboxProps, getLabelProps } = useRadio(radioprops);
  const id = useId(undefined, 'toggle-button');

  const inputProps = getInputProps();
  const checkboxProps = getCheckboxProps();
  const labelProps = getLabelProps();

  return (
    <>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Box as='label' cursor='pointer' pb={2} pr={2} minW={{ base: '100%', sm: '50%', md: 'auto' }} {...labelProps}>
        <input {...inputProps} aria-labelledby={id} />
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        <Button
          bg='white'
          as='div'
          minW={{ base: '100%', md: 'auto' }}
          id={id}
          rounded='lg'
          fontWeight='bold'
          fontSize='sm'
          // size={{ base: '10', md: '12' }}
          borderWidth='1px'
          transition='all 0.2s'
          cursor='pointer'
          boxShadow='xs'
          p={5}
          py={3}
          mr={2}
          color='fg.muted'
          _hover={{ bg: 'gray.100' }}
          _active={{ bg: 'gray.200' }}
          _checked={{
            bg: 'orange.500',
            color: 'white'
          }}
          _focus={{ shadow: 'md' }}
          {...checkboxProps}
          {...rest}
        >
          {children}
        </Button>
      </Box>
    </>
  );
};
